window.Address = {

	changeCountry: function(me){
		
		// reset stuff
		var selected	= me.find(':selected');
		var countryCode = selected.val();
		var hasProvince	= selected.data('hasprovince');

		$('[class*=showWithCountry]').not('.showWithCountry_'+countryCode).hide().find('input').val('');
		$('.showWithCountry_'+countryCode).fadeIn();
		
		if(hasProvince === 'Y' && $('.hasProvince input[name*=_state]').length > 0) {
			if($('.hasProvince input[name*=_state]').tokenInput("clear") !== undefined){
				$('.hasProvince input[name*=_state]').tokenInput("clear");
				$('.hasProvince input').trigger("blur");
				$('.hasProvince').show();
			}
		} else if(hasProvince === 'N') {
			$('.hasProvince').hide();
		}
		
		if($(".tva_intra").length > 0) {
			if(me.find(':selected').attr("euro") === "Y") {
				$(".tva_intra").show();
			}else {
				$(".tva_intra").hide();
			}
		}
		
		// populate steps
	},
	mainAddressCallback : function(data){
		if (data.mainaddress === undefined) {
			return;
		}

		$("#address_"+data.mainaddress.oldaddress+" a.main-star i.icon-star-full-fillout").removeClass("icon-star-full-fillout").addClass("icon-star");
		$("#address_"+data.mainaddress.newaddress+" a.main-star i.icon-star").removeClass("icon-star").addClass("icon-star-full-fillout");
	},
	edit : function(addressid, linkedtype, linkedid){
		var formID = "linkedAddressForm";
		var title = Loc.g('Modifier une adresse');
		
		if(addressid === undefined){
			title = Loc.g("Créer une nouvelle adresse");
			addressid = '';
		}
		
		var options = {
			title	: title,
			buttons	: [
                {text : Loc.g('Annuler'),		click : function(){$(this).dialog("close");}},
                {text : Loc.g("Enregistrer"),	click : function(){
						var buttons		= $(this).parent().find('.ui-dialog-buttonpane');
						var register	= buttons.find('button[type=button]').find('span.ui-button-text').first();
						var body		= $('body');

						register.text(Loc.g('Chargement') + ' ...');
						register.attr('disabled', 'disabled');

						if(body.data('addFormDisabled') === undefined) {
							body.data('addFormDisabled', false);
						}

						if(!body.data('addFormDisabled')) {

							body.data('addFormDisabled', true);
							$("#"+formID).submit();

							setTimeout(function() {

								var buttons		= $('#popupWindow').parent().find('.ui-dialog-buttonpane');
								var register	= buttons.find('button[type=button]').find('span.ui-button-text').first();

								register.text(Loc.g('Enregistrer'));
								body.data('addFormDisabled', false);

							}, 2000);

						}
					}
				}
			],
			callback	: function(){
				var options = {
					success: function(data){
						var formIsOk = MyForm.processJson(data, formID);
						if(formIsOk){
							
							if(data.mainAddrid != undefined) {
								$("#address_"+data.mainAddrid+"_actions a.main-star i.fa").removeClass("fa-star-o").addClass("fa-star");
							}
							
							if(data.mainDelivAddrid != undefined) {
								$("#address_"+data.mainDelivAddrid+"_actions a.main-delivstar i.fa").removeClass("fa-paper-plane-o").addClass("fa-paper-plane");
							}
							
							Utils.reload();
						}
					}, 
					dataType: "json",
					data : {
						addressid	: addressid, 
						linkedid	: linkedid, 
						linkedtype	: linkedtype, 
						action		: "linkedAddressRecord"
					}
				};
					
				MyForm.prepare(formID, "address", options, true);
				MyFacture.initEvent();
			}
		};
		
		MyWindow.load("address", {action: "linkedAddressForm", linkedid: linkedid, linkedtype : linkedtype, addrid: addressid}, options);
	},

	deleteOne : function(addressid, callback){
		if(!Utils.exists("address_"+addressid)){
			return false;
		}
		
		
		var options = {
			type	: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'une adresse"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{text :
					Loc.g("Oui"), 
					click : function(){
                        window.SellsyJS.WebServiceCaller.del(`/rest/addresses/delete/${addressid}`, {}, (data) => {
                            $('#alertWindow').dialog('close');

                            if(data.addrid != undefined){
                                if($.isFunction(callback)){
                                    callback.call(data, data);
                                }

                                $("#address_"+data.addrid).fadeOut('slow', function(){
                                    $(this).remove();
                                });
                            }
                            
                            if(data.mainAddrid != undefined) {
                                $("#address_"+data.mainAddrid+"_actions a.main-star i.fa").removeClass("fa-star-o").addClass("fa-star");
                            }

                            if(data.mainDelivAddrid != undefined) {
                                $("#address_"+data.mainAddrid+" a.main-delivstar i.fa").removeClass("fa-paper-plane-o").addClass("fa-paper-plane");
                            }
                        });
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous supprimer cette adresse ?"), options);

		return true;
    },
    
    deleteOneAddress : function(addressid, callback){
		var options = {
			type	: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'une adresse"),
			buttons		: [
				{text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{text :
					Loc.g("Oui"), 
					click : function(){
                        window.SellsyJS.WebServiceCaller.del(`/rest/addresses/delete/${addressid}`, {}, (data) => {
								$('#alertWindow').dialog('close');
								if($.isFunction(callback)){
                                    callback.call(data, data);
                                }
							}, 
						);
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Voulez-vous supprimer cette adresse ?"), options);

		return true;
	},
	
	updateMainAddress : function(addressid, linkedtype, linkedid, callback){
		var params = {
			action		: "updateMainAddress", 
			addrid		: addressid,
			linkedtype	: linkedtype,
			linkedid	: linkedid
		};
		
		MyFacture.post("address", params, function(data){
				if($.isFunction(callback)){
					callback.call(data, data);
				}
			}, "json");
	},
	
	updateMainDeliveryAddress : function(addressid, linkedtype, linkedid, callback){
		var params = {
			action		: "updateMainDelivAddress", 
			addrid		: addressid,
			linkedtype	: linkedtype,
			linkedid	: linkedid
		};
		
		MyFacture.post("address", params, function(data){
				if($.isFunction(callback)){
					callback.call(data, data);
				}
			}, "json");
	},

};

